import { formatBundleExplosionNumber, formatBundleExplosionUnits } from '../../../lib/bundleDemandExplosionHelpers';

export function BundleDemandExplosionBundleRail({ bundleGroups, onSelectBundle }) {
  return (
    <aside className="rounded-lg border border-gray-200 bg-white p-2 lg:p-4">
      <div>
        <h3 className="text-sm font-semibold text-gray-900">Largest bundle demand drivers</h3>
        <p className="mt-1 text-xs text-gray-500">
          The left rail keeps the highest-volume virtual bundles visible while you audit component propagation and
          unresolved exceptions.
        </p>
      </div>
      <div className="mt-4 space-y-2">
        {bundleGroups.length > 0 ? (
          bundleGroups.map(group => (
            <button
              key={group.executionSku}
              type="button"
              className="w-full rounded-md border border-gray-200 bg-white px-1.5 py-1.5 text-left transition hover:border-gray-300 lg:px-3 lg:py-3"
              onClick={() => onSelectBundle?.(group.executionSku)}
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="truncate text-sm font-medium text-gray-900">{group.executionSku}</p>
                  <p className="mt-1 truncate text-xs text-gray-500">{group.executionProductName}</p>
                  <p className="mt-1 text-xs text-gray-500">
                    {formatBundleExplosionNumber(group.componentCount)} component rows
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-sm font-semibold text-gray-900">
                    {formatBundleExplosionUnits(group.componentUnits)}
                  </p>
                  {group.exceptionCount > 0 ? (
                    <p className="mt-1 text-[11px] text-amber-700">
                      {group.exceptionCount} exception{group.exceptionCount === 1 ? '' : 's'}
                    </p>
                  ) : null}
                </div>
              </div>
            </button>
          ))
        ) : (
          <div className="rounded-md border border-dashed border-gray-200 bg-white px-4 py-6 text-sm text-gray-500">
            No bundle explosion rows are in scope for the current filters.
          </div>
        )}
      </div>
    </aside>
  );
}


